import { paths } from 'src/routes/paths';

import { DashboardLayout } from 'src/layouts/dashboard';

import { SplashScreen } from 'src/components/loading-screen';

import { ForbiddenView } from 'src/sections/error';

import { useIsHqTenant } from '../hooks';

// ----------------------------------------------------------------------

/**
 * 总部后台守卫
 *
 * 仅当前会话租户 code === 0000 可进入 HQ。
 * 其他租户停留在 HQ 布局：侧栏菜单为空，主区展示无权访问。
 * 须套在 AuthGuard、AdminGuard 之内。
 */
type HqGuardProps = {
  children: React.ReactNode;
};

export function HqGuard({ children }: HqGuardProps) {
  const { isHqTenant, loading } = useIsHqTenant();

  if (loading) {
    return <SplashScreen />;
  }

  if (!isHqTenant) {
    return (
      <DashboardLayout navScope="hq">
        <ForbiddenView
          embedded
          backHref={paths.dashboard.root}
          description="平台后台仅总部租户可访问，请返回商户后台。"
        />
      </DashboardLayout>
    );
  }

  return <>{children}</>;
}
